import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { NeedsHousehold } from '../common';
import ShoppingPage from './ShoppingPage';
import AddShoppingItemPage from './AddShoppingItemPage';
import MealPlanShoppingPage from './MealPlanShoppingPage';
import RecurringItemsPage from './RecurringItemsPage';
import RecurringItemEditPage from './RecurringItemEditPage';
import StoresPage from './StoresPage';
import StoreEditPage from './StoreEditPage';

/** Pages under /casa/compras. */
const ShoppingRoutes: React.FC = () => (
  <NeedsHousehold>
    <Routes>
      <Route index element={<ShoppingPage />} />
      <Route path="juntar" element={<AddShoppingItemPage />} />
      <Route path="da-ementa" element={<MealPlanShoppingPage />} />
      <Route path="regulares" element={<RecurringItemsPage />} />
      <Route path="regulares/:id" element={<RecurringItemEditPage />} />
      <Route path="lojas" element={<StoresPage />} />
      <Route path="lojas/:id" element={<StoreEditPage />} />
    </Routes>
  </NeedsHousehold>
);

export default ShoppingRoutes;
